import { render, staticRenderFns } from "./ProfileFollowing.vue?vue&type=template&id=1ae83d78"
import script from "./ProfileFollowing.vue?vue&type=script&lang=js"
export * from "./ProfileFollowing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports